"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardAlert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@clipboard-health/ui-react");
const material_1 = require("@mui/material");
function CardAlert(props) {
    const { label, IconComponent, sx, severity = "error" } = props;
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: 0.5, paddingX: 1, paddingY: 0.125, border: "1px solid", borderColor: (theme) => theme.palette[severity].light, borderRadius: 0.25, bgcolor: (theme) => theme.palette[severity].contrastText, direction: "row", role: "alert", alignItems: "center", ...(sx && { sx }), children: [IconComponent && (0, jsx_runtime_1.jsx)(IconComponent, {}), (0, jsx_runtime_1.jsx)(ui_react_1.Text, { variant: "subtitle2", color: severity, children: label })] }));
}
exports.CardAlert = CardAlert;
//# sourceMappingURL=CardAlert.js.map